<template>
  <div class="tab__content" :class="active ? 'active' : null">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      name: { type: String, default: null },
      active: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
    },
  }

</script>